(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VueRouterMultiguard", [], factory);
	else if(typeof exports === 'object')
		exports["VueRouterMultiguard"] = factory();
	else
		root["VueRouterMultiguard"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition